import { SignupForm } from "../components/form/SignupForm"
import bg1 from '../assets/images/backgrounds/rentic_bg_element1.svg';
import bg3 from '../assets/images/backgrounds/rentic_bg_element3.svg';
import { Helmet } from "react-helmet-async";
import { ResetPasswordForm } from "../components/form/ResetPasswordForm";

export const ResetPasswordPage: React.FC = () => {

    return (
        <div className="w-full h-full flex justify-center items-center">

            <Helmet>
                <title>Rentic - Muuda parooli</title>
                <meta name="keywords" content="rentic, alusta rentimist, loo Renticu konto, Renticu kasutaja, eseme rent" />
                <meta property="og:title" content="Rentic - Profiil" />
                <meta property="og:description" content="Muuda oma parool Renticu rendiplatformil." />
                <meta property="og:image" content="/logo512.png" />
                <meta property="og:url" content="https://rentic.ee/reset_password" />
            </Helmet>

            <img className="absolute top-0 left-0 h-[90%] opacity-35 w-auto pointer-events-none" src={bg1} alt="" />
            <img className="absolute top-0 right-0 h-[50%] opacity-0 lg:opacity-25 object-contain object-top w-auto pointer-events-none" src={bg3} alt="" />
            <div className="mt-[60px] w-full flex justify-center pb-10">
                <ResetPasswordForm />
            </div>
        </div>
    )
}